export default "__VITE_ASSET__DYU44x4R__"